module.exports = __webpack_public_path__ + "static/home-pre-footer-72f6ad629d28f2ace48ee46f035c9886.jpg";